const o = "_typographyContainer_1gdt8_1", r = "_colorColorFgBold_1gdt8_5", e = "_colorColorFgLight_1gdt8_9", t = "_colorColorFgLighter_1gdt8_13", l = "_colorColorFgLightest_1gdt8_17", c = "_colorColorFgBrandDefault_1gdt8_21", g = "_colorColorFgBrandBold_1gdt8_25", n = "_colorColorFgInverseLight_1gdt8_29", a = "_colorColorFgInfoDefault_1gdt8_33", _ = "_colorColorFgInfoBold_1gdt8_37", d = "_colorColorFgWarningDefault_1gdt8_41", y = "_colorColorFgWarningBold_1gdt8_45", p = "_colorColorFgSuccessDefault_1gdt8_49", i = "_colorColorFgSuccessBold_1gdt8_53", s = "_colorColorFgDangerDefault_1gdt8_57", C = "_colorColorFgDangerBold_1gdt8_61", h = "_colorColorFgDefault_1gdt8_65", F = "_colorColorFgInverse_1gdt8_29", f = "_colorColorFgInverseLighter_1gdt8_73", u = "_colorColorFgInverseLightest_1gdt8_77", m = "_colorColorFgSelected_1gdt8_81", A = "_colorColorFgDisabled_1gdt8_85", B = "_colorColorFgAccentRedDefault_1gdt8_89", D = "_colorColorFgAccentRedBold_1gdt8_93", b = "_colorColorFgAccentGreenDefault_1gdt8_97", L = "_colorColorFgAccentGreenBold_1gdt8_101", G = "_colorColorFgAccentOrangeDefault_1gdt8_105", I = "_colorColorFgAccentOrangeBold_1gdt8_109", x = "_colorColorFgAccentPinkDefault_1gdt8_113", R = "_colorColorFgAccentPinkBold_1gdt8_117", v = "_colorColorFgAccentRoseDefault_1gdt8_121", P = "_colorColorFgAccentRoseBold_1gdt8_125", k = "_colorColorFgAccentYellowDefault_1gdt8_129", w = "_colorColorFgAccentYellowBold_1gdt8_133", O = "_colorColorFgAccentCyanDefault_1gdt8_137", S = "_colorColorFgAccentCyanBold_1gdt8_141", T = "_colorColorFgAccentTealDefault_1gdt8_145", V = "_colorColorFgAccentTealBold_1gdt8_149", Y = "_colorColorFgAccentGreenLightDefault_1gdt8_153", W = "_colorColorFgAccentGreenLightBold_1gdt8_157", j = "_colorColorFgAccentRedBolder_1gdt8_161", q = "_colorColorFgAccentGreenBolder_1gdt8_165", z = "_colorColorFgAccentOrangeBolder_1gdt8_169", E = "_colorColorFgAccentPinkBolder_1gdt8_173", H = "_colorColorFgAccentPoseBolder_1gdt8_177", J = "_colorColorFgAccentYellowBolder_1gdt8_181", K = "_colorColorFgAccentVioletDefault_1gdt8_185", M = "_colorColorFgAccentVioletBold_1gdt8_189", N = "_colorColorFgAccentVioletBolder_1gdt8_193", Q = "_colorColorFgAccentTealBolder_1gdt8_197", U = "_colorColorFgAccentGreenLightBolder_1gdt8_201", X = "_colorColorFgAccentCyanBolder_1gdt8_205", Z = "_colorColorFgAccentBlueLightDefault_1gdt8_209", $ = "_colorColorFgAccentBlueLightBold_1gdt8_213", oo = "_colorColorFgAccentBlueLightBolder_1gdt8_217", ro = {
  typographyContainer: o,
  colorColorFgBold: r,
  colorColorFgLight: e,
  colorColorFgLighter: t,
  colorColorFgLightest: l,
  colorColorFgBrandDefault: c,
  colorColorFgBrandBold: g,
  colorColorFgInverseLight: n,
  colorColorFgInfoDefault: a,
  colorColorFgInfoBold: _,
  colorColorFgWarningDefault: d,
  colorColorFgWarningBold: y,
  colorColorFgSuccessDefault: p,
  colorColorFgSuccessBold: i,
  colorColorFgDangerDefault: s,
  colorColorFgDangerBold: C,
  colorColorFgDefault: h,
  colorColorFgInverse: F,
  colorColorFgInverseLighter: f,
  colorColorFgInverseLightest: u,
  colorColorFgSelected: m,
  colorColorFgDisabled: A,
  colorColorFgAccentRedDefault: B,
  colorColorFgAccentRedBold: D,
  colorColorFgAccentGreenDefault: b,
  colorColorFgAccentGreenBold: L,
  colorColorFgAccentOrangeDefault: G,
  colorColorFgAccentOrangeBold: I,
  colorColorFgAccentPinkDefault: x,
  colorColorFgAccentPinkBold: R,
  colorColorFgAccentRoseDefault: v,
  colorColorFgAccentRoseBold: P,
  colorColorFgAccentYellowDefault: k,
  colorColorFgAccentYellowBold: w,
  colorColorFgAccentCyanDefault: O,
  colorColorFgAccentCyanBold: S,
  colorColorFgAccentTealDefault: T,
  colorColorFgAccentTealBold: V,
  colorColorFgAccentGreenLightDefault: Y,
  colorColorFgAccentGreenLightBold: W,
  colorColorFgAccentRedBolder: j,
  colorColorFgAccentGreenBolder: q,
  colorColorFgAccentOrangeBolder: z,
  colorColorFgAccentPinkBolder: E,
  colorColorFgAccentPoseBolder: H,
  colorColorFgAccentYellowBolder: J,
  colorColorFgAccentVioletDefault: K,
  colorColorFgAccentVioletBold: M,
  colorColorFgAccentVioletBolder: N,
  colorColorFgAccentTealBolder: Q,
  colorColorFgAccentGreenLightBolder: U,
  colorColorFgAccentCyanBolder: X,
  colorColorFgAccentBlueLightDefault: Z,
  colorColorFgAccentBlueLightBold: $,
  colorColorFgAccentBlueLightBolder: oo,
  "typography-en-interface-medium-sm": "_typography-en-interface-medium-sm_1gdt8_221",
  "typography-en-interface-medium-m": "_typography-en-interface-medium-m_1gdt8_225",
  "typography-en-subheading": "_typography-en-subheading_1gdt8_229",
  "typography-en-title-1": "_typography-en-title-1_1gdt8_233",
  "typography-en-subtitle-1": "_typography-en-subtitle-1_1gdt8_237",
  "typography-en-caption": "_typography-en-caption_1gdt8_241",
  "typography-en-body-regular": "_typography-en-body-regular_1gdt8_245",
  "typography-en-body-medium": "_typography-en-body-medium_1gdt8_249",
  "typography-en-body-semibold": "_typography-en-body-semibold_1gdt8_253",
  "typography-en-body-bold": "_typography-en-body-bold_1gdt8_257",
  "typography-en-interface-default-s": "_typography-en-interface-default-s_1gdt8_261",
  "typography-en-interface-default-sm": "_typography-en-interface-default-sm_1gdt8_265",
  "typography-en-interface-default-m": "_typography-en-interface-default-m_1gdt8_269",
  "typography-en-interface-default-ml": "_typography-en-interface-default-ml_1gdt8_273",
  "typography-en-interface-default-l": "_typography-en-interface-default-l_1gdt8_277",
  "typography-en-interface-medium-s": "_typography-en-interface-medium-s_1gdt8_221",
  "typography-en-interface-medium-ml": "_typography-en-interface-medium-ml_1gdt8_285",
  "typography-en-interface-medium-l": "_typography-en-interface-medium-l_1gdt8_289",
  "typography-en-interface-strong-xxs": "_typography-en-interface-strong-xxs_1gdt8_293",
  "typography-en-interface-strong-s": "_typography-en-interface-strong-s_1gdt8_297",
  "typography-en-interface-strong-sm": "_typography-en-interface-strong-sm_1gdt8_301",
  "typography-en-interface-strong-m": "_typography-en-interface-strong-m_1gdt8_305",
  "typography-en-interface-strong-ml": "_typography-en-interface-strong-ml_1gdt8_309",
  "typography-en-interface-strong-l": "_typography-en-interface-strong-l_1gdt8_313",
  "typography-ar-subheading": "_typography-ar-subheading_1gdt8_317",
  "typography-ar-title-1": "_typography-ar-title-1_1gdt8_321",
  "typography-ar-subtitle-1": "_typography-ar-subtitle-1_1gdt8_325",
  "typography-ar-caption": "_typography-ar-caption_1gdt8_329",
  "typography-ar-heading": "_typography-ar-heading_1gdt8_333",
  "typography-ar-body-regular": "_typography-ar-body-regular_1gdt8_337",
  "typography-ar-body-medium": "_typography-ar-body-medium_1gdt8_341",
  "typography-ar-body-semibold": "_typography-ar-body-semibold_1gdt8_345",
  "typography-ar-body-bold": "_typography-ar-body-bold_1gdt8_349",
  "typography-ar-interface-default-s": "_typography-ar-interface-default-s_1gdt8_353",
  "typography-ar-interface-default-sm": "_typography-ar-interface-default-sm_1gdt8_357",
  "typography-ar-interface-default-m": "_typography-ar-interface-default-m_1gdt8_361",
  "typography-ar-interface-default-ml": "_typography-ar-interface-default-ml_1gdt8_365",
  "typography-ar-interface-default-l": "_typography-ar-interface-default-l_1gdt8_369",
  "typography-ar-interface-medium-sm": "_typography-ar-interface-medium-sm_1gdt8_373",
  "typography-ar-interface-medium-m": "_typography-ar-interface-medium-m_1gdt8_377",
  "typography-ar-interface-medium-ml": "_typography-ar-interface-medium-ml_1gdt8_381",
  "typography-ar-interface-medium-l": "_typography-ar-interface-medium-l_1gdt8_385",
  "typography-ar-interface-strong-xxs": "_typography-ar-interface-strong-xxs_1gdt8_389",
  "typography-ar-interface-strong-s": "_typography-ar-interface-strong-s_1gdt8_393",
  "typography-ar-interface-strong-m": "_typography-ar-interface-strong-m_1gdt8_397",
  "typography-ar-interface-strong-ml": "_typography-ar-interface-strong-ml_1gdt8_401",
  "typography-ar-interface-strong-l": "_typography-ar-interface-strong-l_1gdt8_405",
  "typography-en-subtitle-2": "_typography-en-subtitle-2_1gdt8_409",
  "typography-en-heading": "_typography-en-heading_1gdt8_413",
  "typography-en-interface-underlined-s": "_typography-en-interface-underlined-s_1gdt8_417",
  "typography-en-interface-underlined-sm": "_typography-en-interface-underlined-sm_1gdt8_421",
  "typography-ar-subtitle-2": "_typography-ar-subtitle-2_1gdt8_425",
  "typography-ar-interface-medium-s": "_typography-ar-interface-medium-s_1gdt8_373",
  "typography-ar-interface-strong-sm": "_typography-ar-interface-strong-sm_1gdt8_433",
  "typography-ar-interface-underlined-s": "_typography-ar-interface-underlined-s_1gdt8_437",
  "typography-ar-interface-underlined-sm": "_typography-ar-interface-underlined-sm_1gdt8_441",
  "typography-en-interface-medium-xxs": "_typography-en-interface-medium-xxs_1gdt8_445",
  "typography-en-interface-medium-xs": "_typography-en-interface-medium-xs_1gdt8_449"
};
export {
  $ as colorColorFgAccentBlueLightBold,
  oo as colorColorFgAccentBlueLightBolder,
  Z as colorColorFgAccentBlueLightDefault,
  S as colorColorFgAccentCyanBold,
  X as colorColorFgAccentCyanBolder,
  O as colorColorFgAccentCyanDefault,
  L as colorColorFgAccentGreenBold,
  q as colorColorFgAccentGreenBolder,
  b as colorColorFgAccentGreenDefault,
  W as colorColorFgAccentGreenLightBold,
  U as colorColorFgAccentGreenLightBolder,
  Y as colorColorFgAccentGreenLightDefault,
  I as colorColorFgAccentOrangeBold,
  z as colorColorFgAccentOrangeBolder,
  G as colorColorFgAccentOrangeDefault,
  R as colorColorFgAccentPinkBold,
  E as colorColorFgAccentPinkBolder,
  x as colorColorFgAccentPinkDefault,
  H as colorColorFgAccentPoseBolder,
  D as colorColorFgAccentRedBold,
  j as colorColorFgAccentRedBolder,
  B as colorColorFgAccentRedDefault,
  P as colorColorFgAccentRoseBold,
  v as colorColorFgAccentRoseDefault,
  V as colorColorFgAccentTealBold,
  Q as colorColorFgAccentTealBolder,
  T as colorColorFgAccentTealDefault,
  M as colorColorFgAccentVioletBold,
  N as colorColorFgAccentVioletBolder,
  K as colorColorFgAccentVioletDefault,
  w as colorColorFgAccentYellowBold,
  J as colorColorFgAccentYellowBolder,
  k as colorColorFgAccentYellowDefault,
  r as colorColorFgBold,
  g as colorColorFgBrandBold,
  c as colorColorFgBrandDefault,
  C as colorColorFgDangerBold,
  s as colorColorFgDangerDefault,
  h as colorColorFgDefault,
  A as colorColorFgDisabled,
  _ as colorColorFgInfoBold,
  a as colorColorFgInfoDefault,
  F as colorColorFgInverse,
  n as colorColorFgInverseLight,
  f as colorColorFgInverseLighter,
  u as colorColorFgInverseLightest,
  e as colorColorFgLight,
  t as colorColorFgLighter,
  l as colorColorFgLightest,
  m as colorColorFgSelected,
  i as colorColorFgSuccessBold,
  p as colorColorFgSuccessDefault,
  y as colorColorFgWarningBold,
  d as colorColorFgWarningDefault,
  ro as default,
  o as typographyContainer
};
//# sourceMappingURL=Typography.module.scss.js.map
